import { FormGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	Button,
	Card,
	CardBody,
	Col,
	Collapse,
	Container,
	Form,
	FormText,
	Input,
	InputGroup,
	Label,
	Row,
	Spinner,
} from 'reactstrap';
import captcha from '../assets/imgs/capcha.png';
import { createRequest, getFaqs } from '../redux/actions/feedback.action';

function Faq() {
	const [activeTab, setActiveTab] = useState(-1);
	const [isOpen, setIsOpen] = useState(-1);
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [subject, setSubject] = useState('');
	const [desc, setDesc] = useState('');
	const [file, setFile] = useState('');

	const { faqs, loading } = useSelector(state => state.feedback);
	const dispatch = useDispatch();
	const toggle = id => setIsOpen(id);
	useEffect(() => {
		if (faqs.length == 0) {
			dispatch(getFaqs());
		}
	}, []);
	return (
		<>
			<div className='faq-sec'>
				<div
					className='faq-banner'
					// style={{ backgroundImage: `url('${faqbanner}')` }}
				>
					<div>
						<h1
							className='text-white text-uppercase text-center'
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 6,
								wordSpacing: 8,
							}}
						>
							How can we help you?
						</h1>
						<InputGroup className='faq-ig'>
							<Input
								placeholder='Search'
								className='faq-search w-100'
								placeholder='Find a soluton'
							/>
							<i className='fa fa-search faq-icon position-absolute'></i>
						</InputGroup>
					</div>
				</div>
				<Container>
					<h1
						className='mb-0 text-center display-4'
						style={{
							fontFamily: 'Ogg',
							letterSpacing: 6,
							wordSpacing: 8,
						}}
					>
						FAQs
					</h1>
					<div className='tabs mt-5 mb-5'>
						<span onClick={() => setActiveTab(-1)}>All</span>
						{faqs.map((faq, idx) => (
							<span
								onClick={e => setActiveTab(idx)}
								className={`tab-item ml-4 ${
									activeTab == idx ? 'active' : ''
								}`}
							>
								{faq.name}
							</span>
						))}
						<h5
							className='font-weight-bold mt-4'
							style={{ color: '#484E9C' }}
						>
							{activeTab != -1
								? faqs.length > 0 && faqs[activeTab].name
								: 'All'}
						</h5>
						{activeTab != -1
							? faqs.length > 0 &&
							  faqs[activeTab].questions.map((quest, idx) => (
									<>
										<hr className='custom-hr my-4' />
										<div
											className='d-flex pointer align-items-center '
											onClick={e =>
												toggle(isOpen != idx ? idx : -1)
											}
										>
											<i
												className={`${
													isOpen == idx
														? 'fa fa-angle-up'
														: 'fa fa-angle-down'
												}`}
												style={{ color: '#D93D13' }}
											></i>
											<h6 className='font-weight-bold ml-2 m-0'>
												{quest.que}
											</h6>
										</div>
										<Collapse isOpen={isOpen == idx}>
											<p
												className='my-3 text-muted'
												style={{ marginLeft: 100 }}
											>
												{quest.ans}
											</p>
										</Collapse>
									</>
							  ))
							: faqs.length > 0 &&
							  faqs.map(
									(faq, index) =>
										faq.questions.length > 0 &&
										faq.questions.map((quest, idx) => {
											return (
												<>
													<hr className='custom-hr my-4' />
													<div
														className='d-flex pointer align-items-center'
														onClick={e =>
															toggle(
																isOpen != idx
																	? idx
																	: -1
															)
														}
													>
														{/* {console.log('isopen', isOpen, 'idex', idx)} */}
														<i
															className={`${
																isOpen == idx
																	? 'fa fa-angle-up'
																	: 'fa fa-angle-down'
															}`}
															style={{
																color: '#D93D13',
															}}
														></i>
														<h6 className='font-weight-bold ml-2 m-0'>
															{quest.que}
														</h6>
													</div>
													<Collapse
														isOpen={isOpen == idx}
													>
														<p
															className='my-3 text-muted'
															style={{
																marginLeft: 100,
															}}
														>
															{quest.ans}
														</p>
													</Collapse>
												</>
											);
										})
							  )}
					</div>

					<Card className='form-card'>
						<h1
							className='mb-lg-5 mb-sm-3 text-uppercase text-center'
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 8,
								wordSpacing: 8,
							}}
						>
							Submit a request
						</h1>
						<Form
							className='formm'
							onSubmit={e => {
								e.preventDefault();
								let obj = {
									name: name,
									email: email,
									subject: subject,
									description: desc,
								};
								dispatch(createRequest(obj, file)).then(res => {
									setName('');
									setEmail('');
									setSubject('');
									setDesc('');
									setFile([]);
								});
							}}
						>
							<div className='d-flex'>
								<FormGroup className='w-100 form-groupp'>
									<Label for='examplename' className='label'>
										Your Full Name
									</Label>
									<Input
										id='examplename'
										name='name'
										type='name'
										required
										value={name}
										onChange={e => setName(e.target.value)}
										style={{ width: '90%' }}
									/>
								</FormGroup>
								<FormGroup className='w-100 form-groupp'>
									<Label for='exampleEmail' className='label'>
										Your Email
									</Label>
									<Input
										id='exampleEmail'
										name='email'
										type='email'
										required
										value={email}
										onChange={e => setEmail(e.target.value)}
									/>
								</FormGroup>
							</div>
							<FormGroup className='form-groupp'>
								<Label for='exampleSelect' className='label'>
									Subject
								</Label>
								<FormText>
									Please state the nature of your support
									request by selecting any of the given types.
								</FormText>
								<Input
									id='exampleSelect'
									name='subject'
									type='text'
									required
									value={subject}
									onChange={e => setSubject(e.target.value)}
								>
									{/* <option></option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option> */}
								</Input>
							</FormGroup>
							<FormGroup className='form-groupp'>
								<Label for='exampleText' className='label'>
									Description
								</Label>
								<FormText>
									Please enter the details of your request. A
									member of our support staff will respond as
									soon as possible.
								</FormText>
								<Input
									id='exampleText'
									name='text'
									type='textarea'
									required
									value={desc}
									onChange={e => setDesc(e.target.value)}
									style={{ height: '120px' }}
								/>
							</FormGroup>
							<FormGroup className='form-groupp'>
								<Label for='exampleFile' className='label'>
									Attachments (optional)
								</Label>
								<FormText>
									Please enter the details of your request. A
									member of our support staff will respond as
									soon as possible.
								</FormText>
								<Input
									id='exampleFile'
									name='file'
									type='file'
									onChange={e => setFile(e.target.files[0])}
								/>
							</FormGroup>
							<div className='d-flex'>
								<div className='w-100'>
									<img src={captcha} width='90%' />
								</div>
								<div className='w-100'>
									<Button
										className='btn-outline px-4 w-100 dashboard-btn'
										type='submit'
										disabled={loading}
									>
										{loading ? (
											<Spinner size='md' />
										) : (
											'Submit'
										)}
									</Button>
								</div>
							</div>
						</Form>
					</Card>
				</Container>
			</div>
		</>
	);
}

export default Faq;
